// slider z ostatnio oglądanymi produktami

import React, { FC, useMemo } from 'react';
import { Trans } from 'react-i18next';
import { ButtonBack, ButtonNext, CarouselProvider, Slide, Slider } from 'pure-react-carousel';
import { ChevronLeft, ChevronRight } from 'react-bootstrap-icons';
import classnames from 'classnames';

import { useRWD } from 'hooks';
import { useGetProductsLastViewed, useGetProductsLastViewedMutation } from 'api';
import { Loader, Link } from 'components/controls';

import styles from 'theme/pages/Product/components/LastViewed/LastViewed.module.scss';

// typ danych wejściowych
interface IProps {
  productId: number;
}

const LastViewed: FC<IProps> = ({ productId }) => {
  const { isMobile } = useRWD();

  // pobranie listy ostanio oglądanych produktów
  const { data: productsLastViewedSimpleData, isLoading: isProductsLastViewedLoading } =
    useGetProductsLastViewed(
      productId,
      {
        page: 1,
        limit: 999
      },
      {
        onSuccess: (data) => {
          refetchProductsFullData({
            scopes: 'PriceProductData',
            productIds: data.items
              .map((item) => item.id)
              .toString()
              .replaceAll(',', '|'),
            page: 1,
            limit: 999
          });
        }
      }
    );

  // Pobranie listy produktów
  const { data: productsLastViewedFullData, mutate: refetchProductsFullData } =
    useGetProductsLastViewedMutation(productId);

  const homeLastViewedData = useMemo(() => {
    return productsLastViewedSimpleData?.items?.map((simpleProduct) => {
      return productsLastViewedFullData
        ? {
            ...simpleProduct,
            ...productsLastViewedFullData?.items.find(
              (fullProduct) => fullProduct.id === simpleProduct.id
            )
          }
        : simpleProduct;
    });
  }, [productsLastViewedSimpleData, productsLastViewedFullData]);

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Pages-Product-components-LastViewed'
      )}>
      <div className={styles.title}>
        <Trans>Ostatnio oglądane</Trans>
      </div>

      {isProductsLastViewedLoading && <Loader />}

      {!!productsLastViewedSimpleData && (
        <CarouselProvider
          naturalSlideWidth={0}
          naturalSlideHeight={0}
          totalSlides={productsLastViewedSimpleData?.items.length || 0}
          visibleSlides={isMobile ? 2.5 : 6}
          className={styles.slider}>
          <ButtonBack disabled={isMobile} className={classnames(styles.navButton, styles.back)}>
            <ChevronLeft />
          </ButtonBack>
          <ButtonNext disabled={isMobile} className={classnames(styles.navButton, styles.next)}>
            <ChevronRight />
          </ButtonNext>
          <Slider>
            {homeLastViewedData?.map((product, index) => (
              <Slide key={product.id} index={index} className={styles.slide}>
                <div className={styles.productWrapper}>
                  <Link
                    to={`/${product.product_basic_short_info?.url_link}`}
                    className={styles.product}>
                    <div
                      className={styles['product-image']}
                      style={{
                        backgroundImage: `url(${product.product_image_formatted_short_info?.images?.[0]?.min})`
                      }}
                    />
                    <div className={styles.description}>
                      {product.product_basic_short_info?.title}
                    </div>
                  </Link>
                </div>
              </Slide>
            ))}
          </Slider>
        </CarouselProvider>
      )}
    </div>
  );
};

export default LastViewed;
